<div class="modal-header" *transloco="let t; prefix: 'parts.modals'">
  <h5 class="modal-title">{{ t('editPart.title') }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'parts.modals'">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>{{ t('fields.partName') }} <span class="required">*</span></label>
      <input
        class="form-control"
        type="text"
        formControlName="partName"
        [placeholder]="isPartLoading ? t('placeholders.loadingPartName') : t('placeholders.enterPartName')"
        [disabled]="true" />
    </div>

    <div class="form-group">
      <label>{{ t('fields.partNumber') }} <span class="required">*</span></label>
      <input
        class="form-control"
        type="text"
        formControlName="partNumber"
        [placeholder]="isPartLoading ? t('placeholders.loadingPartNumber') : t('placeholders.enterPartNumber')"
        [disabled]="true" />
    </div>

    <div class="form-group">
      <label>{{ t('fields.description') }}</label>
      <textarea
        class="form-control textarea"
        formControlName="description"
        rows="3"
        [placeholder]="isPartLoading ? t('placeholders.loadingDescription') : t('placeholders.writeShortDescription')"
        [disabled]="isPartLoading || isLoading"></textarea>
    </div>

    <div class="form-group">
      <label>{{ t('fields.partType') }} <span class="required">*</span></label>
      <div ngbDropdown class="custom-dropdown" [autoClose]="true">
        <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle [disabled]="true">
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle value-text" [class.has-value]="!!form.get('partType')?.value">{{ partTypeLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
      </div>
    </div>

    <div class="form-group">
      <label>{{ t('fields.category') }} <span class="required">*</span></label>
      <div ngbDropdown class="custom-dropdown" [autoClose]="true">
        <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle [disabled]="true">
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle value-text" [class.has-value]="!!form.get('category')?.value">{{ categoryLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>

        <div ngbDropdownMenu>
          <div class="d-flex flex-column">
            @if (isCategoriesLoading) {
              <div class="dropdown-loading">
                <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                <span>{{ t('dropdown.loadingCategories') }}</span>
              </div>
            } @else {
              @for (option of categoryOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('category', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ t('fields.storageLocation') }} <span class="required">*</span></label>
      <div ngbDropdown class="custom-dropdown" [autoClose]="true">
        <button
          type="button"
          class="btn form-control dropdown-toggle"
          ngbDropdownToggle
          [disabled]="isInputLoading || isLoading">
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle value-text" [class.has-value]="!!form.get('storageLocation')?.value">{{ storageLocationLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>

        <div ngbDropdownMenu>
          <div class="d-flex flex-column">
            @if (isStorageLocationsLoading) {
              <div class="dropdown-loading">
                <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                <span>{{ t('dropdown.loadingStorageLocations') }}</span>
              </div>
            } @else {
              @for (option of storageLocationOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('storageLocation', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group third-width">
        <label>{{ t('fields.reorderPoint') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input
              type="number"
              min="0"
              class="form-control dropdown-toggle"
              formControlName="reorderPoint"
              ngbDropdownToggle
              [placeholder]="t('placeholders.enterOrSelect')"
              [disabled]="isPartLoading || isLoading" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of reorderPointOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('reorderPoint', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group third-width">
        <label>{{ t('fields.reorderQuantity') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input
              type="number"
              min="0"
              class="form-control dropdown-toggle"
              formControlName="reorderQuantity"
              ngbDropdownToggle
              [placeholder]="t('placeholders.enterOrSelect')"
              [disabled]="isPartLoading || isLoading" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of reorderQuantityOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('reorderQuantity', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group third-width">
        <label>{{ t('fields.maximumQuantity') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input
              type="number"
              min="0"
              class="form-control dropdown-toggle"
              formControlName="maximumQuantity"
              ngbDropdownToggle
              [placeholder]="t('placeholders.enterOrSelect')"
              [disabled]="isPartLoading || isLoading" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of maximumQuantityOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('maximumQuantity', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()">{{ 'common.cancel' | transloco }}</button>
      <button type="submit" class="save-btn" [disabled]="isLoading || isInputLoading || form.invalid">
        @if (isLoading) {
          <span class="spinner-border"></span>
        } @else {
          <span>{{ t('actions.save') }}</span>
        }
      </button>
    </div>
  </form>
</div>